import React from 'react'
import styled from 'styled-components'
import { FaWhatsapp } from 'react-icons/fa'
import { IoMdCall } from 'react-icons/io'
import { useLocation, withRouter } from 'react-router-dom'
import '../../components/SubFooter/SubFooter.css'

// import ScrolltoTop from '../Scrolltotop/ScrolltoTop'
 
const SubFooter = () => {

    const location = useLocation()
    let tel = ""
    if (location.pathname.includes("/lp/fb/")) {
        tel = "898 898 9393"
    } else if (location.pathname.includes("/lp/")) {
        tel = "898 898 8585"
    } else {
        tel = "898 898 8787"
    }

    return (
        // <SubFooterWrapper>
        <div className="SubFooterWrapper">
            <button>
                <a style={{  color: "#31ccb0"}} href={`tel:+91${tel.trim()}`}>
                 <IoMdCall />  call now
                </a>
            </button>
            <button>
               
                <a href="https://api.whatsapp.com/send?phone=918988988787&amp;text=Hi, I am looking to book my health checkup. Please assist me with the diagnostic test details.">
                <FaWhatsapp />  Book Now
                </a>
            </button>
            
            {/* <ScrolltoTop /> */}
            </div>
        // </SubFooterWrapper>
    )
}



export default SubFooter
